module.exports = __webpack_public_path__ + "static/media/Slide2-mobile.9b3e329e.jpg";